<template>
  <div>
    <div
      class="discipline-item bg-white rounded-lg box-shadow-primary flex mt-8 pl-5 cursor-pointer"
    >
      <div
        @click="handleClick"
        :class="{ active: isActive }"
        class="discipline-box  flex flex-1 py-8"
      >
        <div
          class="discipline-select text-gray-200 rounded-lg  bg-gray-200 flex items-center justify-center "
        >
          <span
            ><svg viewBox="0 0 444.2 444.2" width="10">
              <path
                fill="#ffffff"
                d="M160.4 438.5c-13.7 0-26.8-6-35.7-16.4l-113-131.8c-16.9-19.7-14.6-49.5 5.1-66.4 19.7-16.9 49.4-14.6 66.4 5.1l73.9 86.2L390.4 33.7c36.1-50.6 73.9-22.6 37.7 28.2L198.7 418.8c-8.4 11.8-21.8 19-36.2 19.7h-2.1z"
              /></svg
          ></span>
        </div>
        <div class="discipline-text ml-5 text-gray-600 flex items-center">
          {{ discipline.shortname }}
        </div>
      </div>
      <div
        @click="handleClickExtraFocus"
        :class="{ active: isExtraFocus }"
        class="discipline-foco-extra rounded-l-none rounded-r-lg flex flex-col items-center justify-center px-3"
      >
        <svg viewBox="0 0 29 29" width="35">
          <path
            d="M28.9.9c0-.4-.4-.7-.8-.8-6.7-.7-12.4 2-17.1 6.8-1.3 1.4-2.5 2.8-3.5 4.2-1.7-.1-3.5.7-4.9 2L.2 15.5c-.3.3-.3.7-.1 1 .2.3.6.5 1 .4.6-.1 1.5-.3 2.3-.4h.8c-.5 1-.9 1.9-1.1 2.1-.2.4-.1.9.2 1.1l1.4 1.4c-2 2.8-2.1 4.2-2.1 4.4 0 .4.3.8.9.8.5 0 1.8-.2 4.3-2l1.5 1.5c.3.3.7.3 1.1.1l2-1c0 .7-.1 1.8-.3 3.2-.1.8.9 1.3 1.4.7l2.4-2.4c1.2-1.2 2-3.1 1.9-4.8 1.5-1 3-2.3 4.5-3.7 4.7-4.7 7.3-10.4 6.6-17zm-1.6.8c.1 1.8 0 3.6-.4 5.3-1-.3-2.1-1-3-1.9-.9-.9-1.6-2-1.9-3 1.6-.3 3.4-.5 5.3-.4zm-24 13.2l.6-.6c.7-.7 1.6-1.2 2.4-1.4-.5.7-.9 1.4-1.2 2.1-.6-.1-1.2-.1-1.8-.1zM4.9 19l.8-1.6 1.1 1.1c-.4.5-.8.9-1.1 1.3l-.8-.8zm4.2-.3c.6-.6 1.2-.7 2-.7 0 .7-.1 1.3-.7 1.9-2.6 2.6-4.4 3.8-5.5 4.3.4-1.1 1.5-2.9 4.2-5.5zm.9 5.4l-.9-.9c.4-.3.8-.7 1.3-1.1l1.2 1.2c-.8.4-1.1.5-1.6.8zm4.7 1l-.7.7c.1-.8 0-1.4 0-1.9.6-.4 1.3-.8 2-1.2-.2.9-.7 1.8-1.3 2.4zm-1.6-2.7l-1.5-1.5c1.1-1.2 1.1-2.4 1.1-3.8 0-.5-.4-.8-.8-.8-1.3 0-2.6-.1-3.8 1.1l-1.5-1.5c4-7 8.6-11.4 13.7-13.2.4 1.3 1.2 2.6 2.3 3.7 1.1 1.1 2.4 1.9 3.7 2.3-1.8 5.1-6.2 9.7-13.2 13.7z"
          />
          <path
            d="M21.7 7.3c-1.8-1.8-4.6-1.8-6.4 0-1.8 1.8-1.8 4.6 0 6.4 1.8 1.8 4.6 1.8 6.4 0 1.7-1.8 1.7-4.6 0-6.4zm-1.3 5.1c-1.1 1.1-2.8 1.1-3.8 0-1.1-1.1-1.1-2.8 0-3.8 1.1-1.1 2.8-1.1 3.8 0 1.1 1 1.1 2.8 0 3.8z"
          />
        </svg>
        <p
          class="foco-extra-text mt-1 text-gray-500 text-center leading-none uppercase"
        >
          Foco <br />Extra
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DisciplineButton",

  props: ["discipline"],
  data() {
    return {
      isActive: false,
      isExtraFocus: false
    };
  },

  mounted() {
    this.isActive = this.discipline.selected;
    this.isExtraFocus = this.discipline.extra_focus;
  },
  updated() {
    this.isActive = this.discipline.selected;
    this.isExtraFocus = this.discipline.extra_focus;
  },

  methods: {
    handleClick() {
      this.isActive = !this.isActive;
      this.$emit("clickedSelect", this.discipline.id);
    },

    handleClickExtraFocus() {
      this.isExtraFocus = !this.isExtraFocus;
      this.$emit("clickedExtraFocus", this.discipline.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.discipline-item {
  transition: all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1);
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  &:hover {
    transform: translate(0, -7px);
  }
}
.discipline-select {
  transition: all 0.8s;
  width: 25px;
  height: 25px;

  :hover > & {
    // background-color: #5f4d7c;

    // color: white;
  }
}
.discipline-text {
  font-size: 18px;
  :hover > & {
    color: #5f4d7c;
  }
}

.discipline-box.active {
  .discipline-text {
    color: #5f4d7c;
  }
  .discipline-select {
    background-color: #5f4d7c;
    color: white;
  }
}

.discipline-foco-extra.active {
  background-color: #5f4d7c !important;
  svg {
    fill: #f79b77;
  }
}

.discipline-foco-extra {
  background-color: #edf2f7 !important;
  transition: all 0.5s;

  &:hover {
    background-color: #5f4d7c;
  }
}

svg {
  fill: lightgray;
  transition: all 0.3s;
}
.foco-extra-text {
  font-size: 0.6rem;
}
</style>
